export default {
  designColors: {
    primary: '62,34,65',
    secondary: '0,204,115'
  },
  unknownMenProduct: {
    desktop: {
      '1x': '/images/design/unknown/products/unknown-men-product.webp',
      '2x': '/images/design/unknown/products/unknown-men-product@2x.webp'
    },
    mobile: {
      '1x': '/images/design/unknown/products/unknown-men-product-mob.webp',
      '2x': '/images/design/unknown/products/unknown-men-product-mob@2x.webp'
    }
  },
  defaultProductImage: {
    desktop: {
      '1x': '/img/desktop/boxershorts-preview/men-boxershort.webp',
      '2x': '/img/desktop/boxershorts-preview/men-boxershort_2x.webp'
    }
  },
  defaultModelImage: {
    desktop: {
      '1x': '/img/signup/rize-men-originals-model.webp',
      '2x': '/img/signup/rize-men-originals-model@2x.webp'
    }
  },
  boysDelerium: {
    desktop: {
      '1x': '/img/desktop/boxershorts-preview/boys-boxershort.webp',
      '2x': '/img/desktop/boxershorts-preview/boys-boxershort@2x.webp'
    }
  },
  boysFury: {
    desktop: {
      '1x': '/img/desktop/boxershorts-preview/fury-boys-originals-boxershort.webp',
      '2x': '/img/desktop/boxershorts-preview/fury-boys-originals-boxershort@2x.webp'
    }
  },
  menOriginalsSukaj: {
    desktop: {
      '1x': '/img/desktop/boxershorts-preview/sukaj-men-originals-boxershort.webp',
      '2x': '/img/desktop/boxershorts-preview/sukaj-men-originals-boxershort@2x.webp'
    }
  },
  menOneDelerium: {
    desktop: {
      '1x': '/img/desktop/boxershorts-preview/delerium-men-one-boxershort.webp',
      '2x': '/img/desktop/boxershorts-preview/delerium-men-one-boxershort@2x.webp'
    }
  },
  menOriginalsKenji: {
    desktop: {
      '1x': '/img/desktop/boxershorts-preview/kenji-men-originals-boxershort.webp',
      '2x': '/img/desktop/boxershorts-preview/kenji-men-originals-boxershort@2x.webp'
    }
  },
  defaultPosterImage: {
    desktop: {
      '1x': '/img/homepage/vine-men-originals-poster.webp',
      '2x': '/img/homepage/vine-men-originals-poster@2x.webp'
    }
  },
  defaultHeroImage: {
    desktop: {
      '1x': '/img/homepage/fury-men-originals.webp',
      '2x': '/img/homepage/fury-men-originals@2x.webp'
    },
    mobile: {
      '1x': '/img/homepage/fury-men-originals-mob.webp',
      '2x': '/img/homepage/fury-men-originals-mob@2x.webp'
    }
  },
  defaultBoxerPackagingImage: {
    desktop: {
      '1x': '/img/homepage/package-fury.webp',
      '2x': '/img/homepage/package-fury@2x.webp'
    },
    mobile: {
      '1x': '/img/homepage/package-fury-mob.webp',
      '2x': '/img/homepage/package-fury-mob@2x.webp'
    }
  },
  deliveryMargin: 6
}
